import { ActiveStreamingLabel } from "./ToolCallCardActiveStreamingLabel";

import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";

/**
 * The head of an agent's reply: "Planning next moves" while nothing has shown,
 * and "Thought · n seconds" — how long that took — once something has.
 */
export function PendingPlanningRow({
  thoughtSeconds,
}: {
  /**
   * Seconds before the reply showed anything. Absent while it has shown
   * nothing; ``null`` when it has but the time cannot be told.
   */
  thoughtSeconds?: number | null;
}) {
  const hasShown = thoughtSeconds !== undefined;
  const label = !hasShown
    ? "Planning next moves"
    : thoughtSeconds == null
      ? "Thought"
      : `Thought · ${thoughtSeconds} ${thoughtSeconds === 1 ? "second" : "seconds"}`;

  return (
    <div className={cn(hasShown ? "mb-2" : "mb-0")}>
      <Typography
        component="div"
        level="body-sm"
        className="text-xs [line-height:1.5]"
      >
        <ActiveStreamingLabel active={!hasShown}>{label}</ActiveStreamingLabel>
      </Typography>
    </div>
  );
}
